<button mat-raised-button (click)="locateUser()" color="primary" class="locateButton"><mat-icon>my_location</mat-icon> Localizar</button>
@if (loadingBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div id="map"></div>